import { Dispatch, SetStateAction } from "react";

import { Meta } from "../../types/response";
import { TableColumn } from "../../types/table";
import { getPagination } from "../../utils/pagination";

import styles from "./table.module.css";

interface TableProps {
    columns: TableColumn[];
    data: any[];
    meta: Meta;
    currentPage: number;
    setCurrentPage: Dispatch<SetStateAction<number>>;
}
export const Table = ({ columns, data, meta, currentPage, setCurrentPage }: TableProps) => {
    const pages = getPagination(currentPage, meta?.totalPages ?? 1);

    return (
        <>
            <table className={styles.tableContent}>
                <thead className={styles.tableHeader}>
                    <tr>
                        {columns.map((column) => (
                            <th key={column.key}>{column.name}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row) => (
                        <tr key={row.id}
                            className={row.isHidden ? styles.rowHidden : ''}
                        >
                            {columns.map((column) => (
                                <td key={column.key}
                                    className={column.key === "relatedProducts" ? styles.rowUnderline : ''}
                                >
                                    {column.render ? column.render(row[column.key], row) : row[column.key]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className={styles.pagination}>
                <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>
                    &laquo;
                </button>

                <button
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                >
                    &lt;
                </button>

                {pages.map((page, idx) =>
                    page === "..." ? (
                        <span key={idx} className={styles.dots}>
                            ...
                        </span>
                    ) : (
                        <button
                            key={idx}
                            onClick={() => setCurrentPage(page)}
                            className={page === currentPage ? styles.active : ""}
                        >
                            {page}
                        </button>
                    )
                )}

                <button
                    onClick={() => setCurrentPage((p) => Math.min(p + 1, meta.totalPages))}
                    disabled={currentPage === meta.totalPages}
                >
                    &gt;
                </button>

                <button
                    onClick={() => setCurrentPage(meta.totalPages)}
                    disabled={currentPage === meta.totalPages}
                >
                    &raquo;
                </button>
            </div>
        </>
    );
};  